<template>
  <el-dialog title="打标签" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
      <div style="max-height: 88vh;">
        <div class="flex c-main c-pointer mb20" @click="toPage()">
          <i class="el-icon-plus" color="#60B7DC"></i>
          <span>新建标签组</span>
        </div>
        <div style="max-height: 64vh;overflow-y: auto;">
          <div class="mt20">
            <div class="mb10">业务线</div>
            <div v-for="(item,index) in businessLabelList" :key="item.id" class="label">
              <div style="line-height: 40px;">{{item.name}}:</div>
              <div v-for="(i,index2) in item.children" :key="i.id" class="label-box c-pointer"
                :class="{'label-active':i.isActive}" @click="pickBusiness(index,index2)">{{i.name}}</div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer flexs justify-end" style="padding-top: 10px;">
          <el-button @click="formVisible = false">
            取消
          </el-button>
          <el-button type="primary" @click="doCreate()" :loading="isLoading">
            确认
          </el-button>
        </div>
      </div>
  </el-dialog>
</template>

<script>
  import clientListApi from '@/api/client/clientList'
  import userApi from '@/api/user'
  function initFormBean() {
    const formBean = {
      customerAddDTO: {
        name: null,
        pho: null,
        code: null,
        clevel: null,
        profitRatioId: null,
        shopType: null,
        shopOutpatient: null,
        shopCount: null,
        carryProjects: null,
        addr: [],
        // addrDetail:null,
        wechat: null,
        intentionLevel: null,
        note: null,
        parentId: null,
        customerTagList: null,
        technicianId: null,
        customerJSTagList: null,
        // incomeRatio: null,
        // incomeRatio2: null,
        customerType: 3,
        source: '后台录入'
      },
      customerCertificatesAddDTO: {
        certificatesType: null
      },
      customerRegistrationAddDTO: {
        fee: null,
        payVoucher: null,
        applyVoucher: null
      }
    }
    return formBean
  }

  export default {
    props: {
      // standingList: Array,
      // discountList: Array,
      // configList: Array,
      labelList: Array,
      // addressList: Array,
      // technicianList: Array,
      // businessList: Array,
      // popType: Number
    },
    data() {
      return {
        form: initFormBean(),
        formVisible: false,
        businessLabelList:[],
        id:'',
        isLoading:false
        }
    },
    created() {

    },
    methods: {

      resetForm() {
        this.form = initFormBean()
      },
      handleUpdate(row) {
        console.log('row: ',row,this.labelList);
        this.id=row.id
        let labelList=JSON.parse(JSON.stringify(this.labelList))
        let labelList1=JSON.parse(JSON.stringify(this.labelList))
        this.businessLabelList=labelList.map(item=>{
          item.children.map(i=>{
            i.isActive=row.customerTagList.findIndex(it=>it.id==i.id)==-1?false:true
            return i
          })
          return item
        })
        this.resetForm()
        this.formVisible = true

        this.$nextTick(() => {
          // this.$refs['dataForm'].clearValidate()
          // this.configList.forEach(i => {
          //   if (i.code == "carryProjects") this.options.projectList = i.content.split(',')
          //   if (i.code == "shopType") this.options.storeTypeList = i.content.split(',')
          //   if (i.code == "dayAVGOutpatients") this.options.frequencyList = i.content.split(',')
          //   if (i.code == "employeeNums") this.options.staffNum = i.content.split(',')
          //   console.log('staffNum: ', this.options.staffNum);
          // })
        })
      },
      pickBusiness(index,index2){
        this.businessLabelList[index].children[index2].isActive=!this.businessLabelList[index].children[index2].isActive
      },
      toPage(){
        this.$router.push("/client/labelClient");
      },
      doCreate() {
        // this.$refs["dataForm"].validate((valid) => {
          // if (valid) {
            // console.log('this.form: ', this.form);
            this.isLoading=true
            let customerTagList=[]
            this.businessLabelList.forEach(item=>{
              item.children.forEach(i=>{
                if(i.isActive){
                  customerTagList.push(i.id)
                }
              })
            })
            // let customerJSTagList=[]
            // console.log('customerTagList: ',customerTagList);
            // console.log('customerJSTagList: ',customerJSTagList);
            // return
            userApi.customerTag({id:this.id,list:customerTagList}).then(res=>{
              // console.log('res: ',res);
              this.$message.success('操作成功')
              this.formVisible = false;
              this.$emit('created')
              this.isLoading=false
            }).catch(res=>{
                this.isLoading=false
              })
          // }
        // });
      },
    }
  }
</script>
<style lang="scss" scoped>
  .label{
    display: flex;
    margin-bottom: 26px;

    &>div{
      height: 40px;
      margin-right: 18px;
      // line-height: 40px;
    }

    .label-box{
      padding: 12px 24px;
      border-radius: 4px;
      border: 1px solid #D9D9D9
    }

    .label-active{
      border: 1px solid #60B7DC;
      background: #5DBDE733;
    }
  }
  ::v-deep .el-upload--picture-card {
    width: 54px;
    height: 54px;
    line-height: 62px;
  }

  ::v-deep .el-upload-list__item {
    width: 54px;
    height: 54px;
  }

  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .el-cascader {
    width: 100%;
  }

  ::v-deep .el-dialog {
    max-height: 88vh;
    margin-top: 6vh !important;
  }

  ::v-deep .el-form {
    max-height: 64vh !important;
    overflow-y: auto;
  }

  .el-form-item--small.el-form-item {
    width: 48%;
    display: inline-block;
    vertical-align: top;
  }

  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: 100%;
  }

  .el-form-item--small.el-form-item.width100 {
    width: 97%;
  }

  ::v-deep .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 54px;
      height: 54px;
      line-height: 54px;
      text-align: center;
    }
    .avatar {
      width: 54px;
      height: 54px;
      display: block;
    }

    .card-uploader img{
      height: 132px;
      width: 194px;
      margin-right: 56px;
    }
</style>
